import { ValidationLabels } from '@constants_iqfu';

export const outputAlertMessage = (alertsData: string[]) => {
  let alertProperties: string[] = [];
  let alertMessages: string[] = [];

  alertsData?.forEach((data: any) => {
    const alertProperty = Object.keys(data)[0];
    const alertMessage = data[alertProperty];
    alertProperties.push(alertProperty);
    alertMessages.push(alertMessage);
  });

  //重複削除
  alertProperties = alertProperties.filter(function (item, index, self) {
    return self.indexOf(item) === index;
  });

  // 特定のエラーメッセージに対する特別な処理
  if (alertMessages.includes('effective_date_or_expiry_date_is_invalid')) {
    return '締結日または有効期限の年月日に誤りがあるため、申請できません。';
  }

  // 住所フィールドに不正な文字が含まれている場合
  if (alertProperties.includes('address') && alertMessages.includes('invalid')) {
    return '町域以下に不正な文字が含まれています';
  }

  let labelNames: string[] = [];
  alertProperties?.forEach((alertProperty: string) => {
    const targetLabel = ValidationLabels.filter((label) => {
      return label.formName === alertProperty;
    });
    if (targetLabel.length > 0) {
      labelNames.push(targetLabel[0].label);
    }
  });

  const AlertMessage = labelNames.join('、') + 'が不正です。';
  return AlertMessage;
};
